import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
export function generateBrandUrlForProductPage(brandToken, productToken, queries) {
    return brandPage(brandToken, generateBrandPageQueryObjForProductPage(productToken, queries));
}
export function generateBrandPageQueryObjForProductPage(productToken, queries) {
    var _$_object_spread = _object_spread({}, ProductPagePaths.index.parseSearch(getLocationOrThrow().search), queries || {}), refS = _$_object_spread.refS, bCat = _$_object_spread.bCat, bSortBy = _$_object_spread.bSortBy, bQ = _$_object_spread.bQ, bSortingHint = _$_object_spread.bSortingHint, bPage = _$_object_spread.bPage, bRefS = _$_object_spread.bRefS, bRefC = _$_object_spread.bRefC, originalBRefF = _$_object_spread.bRefF, productRefC = _$_object_spread.refC, originalRefF = _$_object_spread.refF, bFilters = _$_object_spread.bFilters;
    var refF = typeof originalRefF === "string" ? [
        originalRefF
    ] : originalRefF;
    var bRefF = typeof originalBRefF === "string" ? [
        originalBRefF
    ] : originalBRefF;
    // If productRefC is present, then user is coming from Category Page, i.e. no need for `b`Refs
    if (productRefC) {
        // see BrandProducts#fetchProducts
        return {
            sortingHint: true,
            // search->product->brand brand page should inherit search referrer from product
            refC: productRefC,
            refF: refF
        };
    }
    var filters;
    var _bFilters_length;
    if (((_bFilters_length = bFilters === null || bFilters === void 0 ? void 0 : bFilters.length) !== null && _bFilters_length !== void 0 ? _bFilters_length : 0) > 0) {
        filters = bFilters;
    }
    // see BrandProducts#fetchProducts
    return {
        cat: bCat,
        sortBy: bSortBy,
        q: bQ,
        sortingHint: bSortingHint,
        // search->product->brand brand page should inherit search referrer from product
        refS: bRefS || refS,
        page: bPage,
        refC: bRefC,
        refF: bRefF,
        refP: [
            productToken
        ],
        filters: filters
    };
}
